// src/pages/CRM/Core/crmEnums.js

// Contact Status
export const ContactStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ARCHIVED: 'ARCHIVED'
};

export const ContactStatusLabels = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived'
};

export const ContactStatusColors = {
  ACTIVE: 'success',
  INACTIVE: 'warning',
  ARCHIVED: 'default'
};

// Lead Status
export const LeadStatus = {
  NEW: 'NEW',
  CONTACTED: 'CONTACTED',
  QUALIFIED: 'QUALIFIED',
  CONVERTED: 'CONVERTED',
  RECYCLED: 'RECYCLED',
  DISQUALIFIED: 'DISQUALIFIED'
};

export const LeadStatusLabels = {
  NEW: 'New',
  CONTACTED: 'Contacted',
  QUALIFIED: 'Qualified',
  CONVERTED: 'Converted',
  RECYCLED: 'Recycled',
  DISQUALIFIED: 'Disqualified'
};

export const LeadStatusColors = {
  NEW: 'info',
  CONTACTED: 'primary',
  QUALIFIED: 'success',
  CONVERTED: 'success',
  RECYCLED: 'warning',
  DISQUALIFIED: 'error'
};

// Lead Score
export const LeadScore = {
  HOT: 'HOT',
  WARM: 'WARM',
  COLD: 'COLD'
};

export const LeadScoreLabels = {
  HOT: 'Hot 🔥',
  WARM: 'Warm',
  COLD: 'Cold'
};

export const LeadScoreColors = {
  HOT: 'error',
  WARM: 'warning',
  COLD: 'info'
};

// Lead Source
export const LeadSource = {
  WEB_FORM: 'WEB_FORM',
  MANUAL_ENTRY: 'MANUAL_ENTRY',
  BUSINESS_CARD: 'BUSINESS_CARD',
  REFERRAL: 'REFERRAL',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  EMAIL_CAMPAIGN: 'EMAIL_CAMPAIGN',
  CHATBOT: 'CHATBOT',
  OTHER: 'OTHER'
};

export const LeadSourceLabels = {
  WEB_FORM: 'Web Form',
  MANUAL_ENTRY: 'Manual Entry',
  BUSINESS_CARD: 'Business Card',
  REFERRAL: 'Referral',
  SOCIAL_MEDIA: 'Social Media',
  EMAIL_CAMPAIGN: 'Email Campaign',
  CHATBOT: 'Chatbot',
  OTHER: 'Other'
};

// Account Type
export const AccountType = {
  PROSPECT: 'PROSPECT',
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  VENDOR: 'VENDOR',
  COMPETITOR: 'COMPETITOR',
  GENERAL: 'GENERAL',
  OTHER: 'OTHER'
};

export const AccountTypeLabels = {
  PROSPECT: 'Prospect',
  CUSTOMER: 'Customer',
  PARTNER: 'Partner',
  VENDOR: 'Vendor',
  COMPETITOR: 'Competitor',
  GENERAL: 'General',
  OTHER: 'Other'
};

export const AccountTypeColors = {
  PROSPECT: 'info',
  CUSTOMER: 'success',
  PARTNER: 'primary',
  VENDOR: 'warning',
  COMPETITOR: 'error',
  GENERAL: 'secondary',
  OTHER: 'default'
};

// Account Status
export const AccountStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ARCHIVED: 'ARCHIVED'
};

export const AccountStatusLabels = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived'
};

// Activity Type
export const ActivityType = {
  EMAIL: 'EMAIL',
  CALL: 'CALL',
  MEETING: 'MEETING',
  NOTE: 'NOTE',
  TASK: 'TASK',
  SMS: 'SMS',
  CHAT: 'CHAT'
};

export const ActivityTypeLabels = {
  EMAIL: 'Email',
  CALL: 'Call',
  MEETING: 'Meeting',
  NOTE: 'Note',
  TASK: 'Task',
  SMS: 'SMS',
  CHAT: 'Chat'
};

export const ActivityTypeIcons = {
  EMAIL: 'Email',
  CALL: 'Phone',
  MEETING: 'Event',
  NOTE: 'Note',
  TASK: 'Assignment',
  SMS: 'Sms',
  CHAT: 'Chat'
};

// Relationship Types
export const RelationshipType = {
  ASSISTANT_TO: 'ASSISTANT_TO',
  REPORTS_TO: 'REPORTS_TO',
  SPOUSE_OF: 'SPOUSE_OF',
  COLLEAGUE: 'COLLEAGUE',
  REFERRED_BY: 'REFERRED_BY',
  OTHER: 'OTHER'
};

export const RelationshipTypeLabels = {
  ASSISTANT_TO: 'Assistant To',
  REPORTS_TO: 'Reports To',
  SPOUSE_OF: 'Spouse Of',
  COLLEAGUE: 'Colleague',
  REFERRED_BY: 'Referred By',
  OTHER: 'Other'
};

// Industries (common list)
export const Industries = [
  'Agriculture',
  'Automotive',
  'Banking',
  'Biotechnology',
  'Construction',
  'Consulting',
  'Education',
  'Electronics',
  'Energy',
  'Entertainment',
  'Financial Services',
  'Food & Beverage',
  'Government',
  'Healthcare',
  'Hospitality',
  'Insurance',
  'Legal',
  'Manufacturing',
  'Media',
  'Non-Profit',
  'Pharmaceuticals',
  'Politics',
  'Real Estate',
  'Retail',
  'Software',
  'Technology',
  'Telecommunications',
  'Transportation',
  'Utilities',
  'Other'
];

// Helper functions
export const getStatusColor = (status, type = 'contact') => {
  if (type === 'lead') return LeadStatusColors[status] || 'default';
  if (type === 'account') return AccountTypeColors[status] || 'default';
  return ContactStatusColors[status] || 'default';
};

export const getScoreColor = (score) => {
  return LeadScoreColors[score] || 'default';
};

// Opportunity Stage
export const OpportunityStage = {
  PROSPECTING: 'PROSPECTING',
  QUALIFICATION: 'QUALIFICATION',
  NEEDS_ANALYSIS: 'NEEDS_ANALYSIS',
  VALUE_PROPOSITION: 'VALUE_PROPOSITION',
  PROPOSAL: 'PROPOSAL',
  NEGOTIATION: 'NEGOTIATION',
  CLOSED_WON: 'CLOSED_WON',
  CLOSED_LOST: 'CLOSED_LOST'
};

export const OpportunityStageLabels = {
  PROSPECTING: 'Prospecting',
  QUALIFICATION: 'Qualification',
  NEEDS_ANALYSIS: 'Needs Analysis',
  VALUE_PROPOSITION: 'Value Proposition',
  PROPOSAL: 'Proposal',
  NEGOTIATION: 'Negotiation',
  CLOSED_WON: 'Closed Won',
  CLOSED_LOST: 'Closed Lost'
};

export const OpportunityStageProbability = {
  PROSPECTING: 10,
  QUALIFICATION: 20,
  NEEDS_ANALYSIS: 40,
  VALUE_PROPOSITION: 60,
  PROPOSAL: 75,
  NEGOTIATION: 90,
  CLOSED_WON: 100,
  CLOSED_LOST: 0
};

export const OpportunityStageColors = {
  PROSPECTING: 'default',
  QUALIFICATION: 'info',
  NEEDS_ANALYSIS: 'info',
  VALUE_PROPOSITION: 'primary',
  PROPOSAL: 'primary',
  NEGOTIATION: 'warning',
  CLOSED_WON: 'success',
  CLOSED_LOST: 'error'
};

// Opportunity Type
export const OpportunityType = {
  NEW_BUSINESS: 'NEW_BUSINESS',
  EXISTING_BUSINESS: 'EXISTING_BUSINESS',
  RENEWAL: 'RENEWAL',
  UPSELL: 'UPSELL',
  CROSS_SELL: 'CROSS_SELL'
};

export const OpportunityTypeLabels = {
  NEW_BUSINESS: 'New Business',
  EXISTING_BUSINESS: 'Existing Business',
  RENEWAL: 'Renewal',
  UPSELL: 'Upsell',
  CROSS_SELL: 'Cross-Sell'
};

// Lead Scoring Rule Types
export const LeadScoringRuleType = {
  DEMOGRAPHIC: 'DEMOGRAPHIC',
  BEHAVIORAL: 'BEHAVIORAL',
  ENGAGEMENT: 'ENGAGEMENT',
  FIRMOGRAPHIC: 'FIRMOGRAPHIC'
};

export const LeadScoringRuleTypeLabels = {
  DEMOGRAPHIC: 'Demographic',
  BEHAVIORAL: 'Behavioral',
  ENGAGEMENT: 'Engagement',
  FIRMOGRAPHIC: 'Firmographic'
};

// Lead Scoring Fields
export const LeadScoringFieldType = {
  JOB_TITLE: 'JOB_TITLE',
  INDUSTRY: 'INDUSTRY',
  COMPANY_SIZE: 'COMPANY_SIZE',
  ANNUAL_REVENUE: 'ANNUAL_REVENUE',
  COUNTRY: 'COUNTRY',
  EMAIL_OPENED: 'EMAIL_OPENED',
  LINK_CLICKED: 'LINK_CLICKED',
  FORM_SUBMITTED: 'FORM_SUBMITTED',
  PAGE_VISITED: 'PAGE_VISITED',
  CHATBOT_INTERACTION: 'CHATBOT_INTERACTION',
  DAYS_SINCE_LAST_ACTIVITY: 'DAYS_SINCE_LAST_ACTIVITY',
  TOTAL_INTERACTIONS: 'TOTAL_INTERACTIONS',
  EMAIL_REPLIES: 'EMAIL_REPLIES'
};

export const LeadScoringFieldTypeLabels = {
  JOB_TITLE: 'Job Title',
  INDUSTRY: 'Industry',
  COMPANY_SIZE: 'Company Size (Employees)',
  ANNUAL_REVENUE: 'Annual Revenue',
  COUNTRY: 'Country',
  EMAIL_OPENED: 'Email Opened',
  LINK_CLICKED: 'Link Clicked',
  FORM_SUBMITTED: 'Form Submitted',
  PAGE_VISITED: 'Page Visited',
  CHATBOT_INTERACTION: 'Chatbot Interaction',
  DAYS_SINCE_LAST_ACTIVITY: 'Days Since Last Activity',
  TOTAL_INTERACTIONS: 'Total Interactions',
  EMAIL_REPLIES: 'Email Replies'
};

// Lead Scoring Operators
export const LeadScoringOperator = {
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  IN_LIST: 'IN_LIST',
  NOT_IN_LIST: 'NOT_IN_LIST',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY'
};

export const LeadScoringOperatorLabels = {
  EQUALS: 'Equals',
  NOT_EQUALS: 'Does Not Equal',
  CONTAINS: 'Contains',
  NOT_CONTAINS: 'Does Not Contain',
  GREATER_THAN: 'Greater Than',
  LESS_THAN: 'Less Than',
  GREATER_THAN_OR_EQUAL: 'Greater Than or Equal',
  LESS_THAN_OR_EQUAL: 'Less Than or Equal',
  IN_LIST: 'In List',
  NOT_IN_LIST: 'Not In List',
  IS_EMPTY: 'Is Empty',
  IS_NOT_EMPTY: 'Is Not Empty'
};
